import React, { FC, useMemo } from 'react';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Card, Switch } from 'antd';
import { groupBy } from 'lodash';
import GroupedTaskDisplay from '../ow_inline_todo_list/GroupedTaskDisplay';

const PMTemplateTasksDisplay: FC<any> = ({ plannedMaintenanceTemplate }): React.ReactElement => {
	const allTasks = useMemo(
		() => nullSafeGetOrElse('tasks.tasks', plannedMaintenanceTemplate, []),
		[plannedMaintenanceTemplate]
	);

	const sortedTasks = useMemo(() => {
		return allTasks
			.map((_) => ({ ..._, groupTitle: nullSafeGetOrElse('groupTitle', _, '') }))
			.sort((a, b) => a - b);
	}, [allTasks]);

	const groupedTasks = useMemo(() => {
		const grouped = groupBy(sortedTasks, (task) => task.groupTitle || '');
		return Object.keys(grouped).map((key) => ({
			groupTitle: key,
			tasks: grouped[key],
		}));
	}, [sortedTasks]);

	return allTasks.length > 0 ? (
		<div className="mt-2">
			<Card
				title="Tasks"
				extra={
					<div>
						<Switch
							disabled
							checked={nullSafeGetOrElse(
								'tasks.taskCompletionMandatory',
								plannedMaintenanceTemplate,
								false
							)}
						/>
						<label className="ml-2">All Tasks Required</label>
					</div>
				}
			>
				<GroupedTaskDisplay groupedTasks={groupedTasks} isAllowedToEdit={false} notCheckable />
			</Card>
		</div>
	) : null;
};

export default PMTemplateTasksDisplay;
